import { MyShopPointOfServiceState } from './reducers/my-shop-point-of-service.reducer';

export const MYSHOP_FEATURE = 'myShop';

export interface MyShopState {
  pointOfService: MyShopPointOfServiceState;
}

export interface StateWithMyShop {
  [MYSHOP_FEATURE]: MyShopState;
}
